import React from "react";
import { Link } from "react-router-dom";
import { AU26, SU26, CATEGORIES } from "../../services/catalog.ts";
import styled from "styled-components";
import HeaderButton from "./HeaderButton.tsx";
import Search from "./icons/Search.tsx";

/*
 * Пунктів стало 14 замість 6 -- меню вище за екран телефона. З overflow: hidden
 * прокрутити його неможливо, і жест ішов на сторінку під ним. Тому відкрите меню
 * скролиться саме, обмежене висотою екрана, а overscroll-behavior: contain не дає
 * скролу перекинутись на фон, коли доїхали до краю.
 */
const List = styled.ol<{ show: boolean }>`
  overflow-y: ${(props) => (props.show ? "auto" : "hidden")};
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  max-height: ${(props) => (props.show ? "calc(100dvh - 55px)" : "none")};
  pointer-events: ${(props) => (props.show ? "auto" : "none")};
  transform: ${(props) => (props.show ? "scaleY(1)" : "scaleY(0)")};
  opacity: ${(props) => (props.show ? "1" : "0")};
  transform-origin: top;
  transition: transform 0.75s ease-in-out, opacity 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  list-style-type: none;
  gap: 0.75rem;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 55px;
  z-index: 3;
  padding: ${(props) => (props.show ? "0 16px" : "0")};
  background-color: #fff;
  margin: 0;
  border-bottom: ${(props) => (props.show ? "1px solid #d0d4dd" : "none")};

  li:not(:last-child) {
    border-bottom: 1px solid #d0d4dd;
  }

  li {
    padding-top: ${(props) => (props.show ? "18px" : "0")};
    padding-bottom: ${(props) => (props.show ? "18px" : "0")};
    transition: padding 0.75s ease-in-out;
  }
`;


const NavMobile = ({ open, setOpen }) => {
  return (
    <List show={open}>
      <li>
        <Link to={"/men"} onClick={() => setOpen(false)}>
          <HeaderButton text={"ЧОЛОВIКАМ"} />
        </Link>
      </li>
      <li>
        <Link to={"/women"} onClick={() => setOpen(false)}>
          <HeaderButton text={"ЖIНКАМ"} />
        </Link>
      </li>
      <li>
          <Link to={`/${AU26.slug}`} onClick={() => setOpen(false)}>
                <HeaderButton text={AU26.label} />
          </Link>
      </li>
      <li>
          <Link to={`/${SU26.slug}`} onClick={() => setOpen(false)}>
              <HeaderButton text={SU26.label} />
          </Link>
      </li>
      {CATEGORIES.map((c) => (
        <li key={c.slug}>
          <Link to={`/c/${c.slug}`} onClick={() => setOpen(false)}>
            <HeaderButton text={c.label.toLocaleUpperCase()} />
          </Link>
        </li>
      ))}
      <li>
        <Link to="/research" onClick={() => setOpen(false)}>
          <HeaderButton text={"Дослідження".toLocaleUpperCase()} />
        </Link>
      </li>
      {/* <li>
        <a href="#">
          <Search />
        </a>
      </li> */}
    </List>
  );
};

export default NavMobile;
